<script setup>
    import bizumLogo from '@/assets/images/paycomet/apm-bizum.svg';
    import { useBizumPago } from '@/composables/front/checkout/useBizumPago.js';

    const props = defineProps({
        session_id: {
            type: String,
            default: ''
        },
        tipo_venta: {
            type: String,
            default: 'evento'
        }
    });

    const emit = defineEmits(['error']);

    const { pagarConBizum, pagarConBizumLoading } = useBizumPago({
        sessionId: props.session_id,
        tipoVenta: props.tipo_venta,
        onError: msg => emit('error', msg)
    });
</script>

<template>
    <!--
      Shell-less: outer border + trust strip live in PaymentStep.vue. This renders
      only the Bizum action panel (icon + title + description + pay button) that
      fills the form-zone when Bizum is the active method (state B).
    -->
    <div data-test="bizum-payment-form" class="tw:flex tw:flex-col tw:items-center tw:text-center">
        <div class="tw:flex tw:justify-center tw:mb-4">
            <img
                :src="bizumLogo"
                alt="Bizum"
                class="tw:h-12 tw:w-auto"
                loading="lazy"
            />
        </div>
        <h3 class="tw:text-base tw:font-bold tw:uppercase tw:tracking-wide tw:text-site tw:mb-1.5">
            {{ $t('pago.method_bizum_title') }}
        </h3>
        <p class="tw:text-sm tw:text-site/60 tw:max-w-sm tw:mx-auto tw:mb-5 tw:leading-relaxed">
            {{ $t('pago.bizum_description') }}
        </p>
        <button
            type="button"
            data-test="bizum-pay"
            class="tw:w-full tw:py-3 tw:bg-site tw:text-white tw:font-bold tw:uppercase tw:tracking-[0.15em] tw:rounded-md hover:tw:bg-black tw:transition-colors tw:flex tw:items-center tw:justify-center tw:gap-2.5 tw:text-sm disabled:tw:opacity-50 disabled:tw:cursor-not-allowed focus:tw:outline-none focus-visible:tw:ring-2 focus-visible:tw:ring-site focus-visible:tw:ring-offset-2"
            :disabled="pagarConBizumLoading"
            @click="pagarConBizum"
        >
            <span
                v-if="pagarConBizumLoading"
                class="tw:inline-block tw:w-4 tw:h-4 tw:border-2 tw:border-white/30 tw:border-t-white tw:rounded-full tw:animate-spin"
            ></span>
            <span>{{ pagarConBizumLoading ? $t('pago.processing') : $t('pago.bizum_cta') }}</span>
        </button>
    </div>
</template>
